interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
  light = false,
}: SectionHeadingProps) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-3 max-w-3xl ${alignCls} ${align === "center" ? "mx-auto" : ""}`}>
      <span
        className={`inline-flex items-center gap-2 text-xs font-label tracking-widest uppercase px-3 py-1 rounded-full ${
          light
            ? "bg-background-50/15 text-background-100"
            : "bg-primary-100 text-primary-700"
        }`}
      >
        <i className="ri-sparkling-2-line"></i>
        {eyebrow}
      </span>
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold leading-snug ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`text-sm md:text-base leading-relaxed ${
            light ? "text-background-100/90" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}